<template>
    <modal :show.sync="modals.classic">
        <h4 slot="header" class="profile-title">
            {{ $t("app.profile.title") }}
        </h4>
        <div class="row">
            <div class="col-md-4">
                <el-upload
                    class="avatar-uploader"
                    :on-change="handleFile"
                    action="#"
                    :show-file-list="false"
                    :auto-upload="false"
                    :on-success="handleAvatarSuccess"
                    :before-upload="beforeAvatarUpload">
                    <img v-if="imageUrl" :src="imageUrl" class="rounded-circle profile-img" title="Perfil" alt="Perfil" />
                    <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                </el-upload>
            </div>
            <div class="col-md-4 profile-label">
                {{ this.$store.state.user.nombre }}
            </div>
            <div class="col-md-4">
                <a class="dropdown-item" href="#" @click="closeSesion">
                    {{ $t("app.nav_bar.admin.account.close_session") }}
                </a>
            </div>
        </div>
        <div class="row">&nbsp;</div>
        <div class="row">
            <div class="col-md-6">
                <fg-input
                    type="text"
                    :label="$t('app.modules.customers.business_name')"
                    :placeholder="$t('app.modules.customers.business_name')"
                    :disabled="true"
                    class="profile-label"
                    v-model="this.cliente.razonSocial"
                >
                </fg-input>
                <fg-input
                    type="text"
                    :label="$t('app.profile.title')"
                    :placeholder="$t('app.profile.title')"
                    :disabled="true"
                    class="profile-label"
                    v-model="this.department"
                >
                </fg-input>
                
            </div>
            <div class="col-md-6">
                <fg-input
                    type="text"
                    :label="$t('app.profile.contact.email')"
                    :placeholder="$t('app.profile.contact.email')"
                    :disabled="true"
                    class="profile-label"
                    v-model="this.contacto.email"
                >
                </fg-input>
                <fg-input
                    type="text"
                    :label="$t('app.profile.contact.cellphone')"
                    :placeholder="$t('app.profile.contact.cellphone')"
                    :disabled="true"
                    class="profile-label"
                    v-model="this.contacto.telefono"
                >
                </fg-input>
            </div>
        </div>
        <div class="row">
            <h4 class="col-md-12 profile-label">{{ $t('app.profile.fiscal_address.title') }}</h4>
        </div>
        <div class="row">
            <div class="col-md-6">
                <fg-input
                    type="text"
                    :label="$t('app.profile.fiscal_address.rfc')"
                    :placeholder="$t('app.profile.fiscal_address.rfc')"
                    :disabled="true"
                    class="profile-label"
                    v-model="this.cliente.rfc"
                >
                </fg-input>
                <fg-input
                    type="text"
                    :label="$t('app.profile.fiscal_address.street')"
                    :placeholder="$t('app.profile.fiscal_address.street')"
                    :disabled="true"
                    class="profile-label"
                    v-model="this.cliente.calle"
                >
                </fg-input>
                <fg-input
                    type="text"
                    :label="$t('app.profile.fiscal_address.number')"
                    :placeholder="$t('app.profile.fiscal_address.number')"
                    :disabled="true"
                    class="profile-label"
                    v-model="this.cliente.numExterior"
                >
                </fg-input>
                <fg-input
                    type="text"
                    :label="$t('app.profile.fiscal_address.number_int')"
                    :placeholder="$t('app.profile.fiscal_address.number_int')"
                    :disabled="true"
                    class="profile-label"
                    v-model="this.cliente.numInterior"
                >
                </fg-input>
                <!--
                <fg-input
                    type="text"
                    :label="$t('app.profile.fiscal_address.block')"
                    :placeholder="$t('app.profile.fiscal_address.block')"
                    :disabled="true"
                    class="profile-label"
                    v-model="this.cliente.colonia"
                >
                

                </fg-input>
                -->
                <fg-input
                    type="text"
                    :label="$t('app.profile.fiscal_address.city')"
                    :placeholder="$t('app.profile.fiscal_address.city')"
                    :disabled="true"
                    class="profile-label"
                    v-model="this.cliente.delegacionMunicipio"
                >
                </fg-input>
                <fg-input
                    type="text"
                    :label="$t('app.profile.fiscal_address.postal_code')"
                    :placeholder="$t('app.profile.fiscal_address.postal_code')"
                    :disabled="true"
                    class="profile-label"
                    v-model="this.cliente.codigoPostal"
                >
                </fg-input>
            </div>
            <div class="col-md-6">
                <fg-input
                    type="text"
                    :label="$t('app.profile.fiscal_address.state')"
                    :placeholder="$t('app.profile.fiscal_address.state')"
                    :disabled="true"
                    class="profile-label"
                    v-model="this.cliente.estado"
                >
                </fg-input>
                <fg-input
                    type="text"
                    :label="$t('app.profile.fiscal_address.country')"
                    :placeholder="$t('app.profile.fiscal_address.country')"
                    :disabled="true"
                    class="profile-label"
                    v-model="this.cliente.pais"
                >
                </fg-input>
                <fg-input
                    type="text"
                    :label="$t('app.profile.fiscal_address.language')"
                    :placeholder="$t('app.profile.fiscal_address.language')"
                    :disabled="true"
                    class="profile-label"
                    v-model="this.cliente.idioma"
                >
                </fg-input>
                <fg-input
                    type="text"
                    :label="$t('app.profile.fiscal_address.phone01')"
                    :placeholder="$t('app.profile.fiscal_address.phone01')"
                    :disabled="true"
                    class="profile-label"
                    v-model="this.cliente.telefono1"
                >
                </fg-input>
                <fg-input
                    type="text"
                    :label="$t('app.profile.fiscal_address.phone02')"
                    :placeholder="$t('app.profile.fiscal_address.phone02')"
                    :disabled="true"
                    class="profile-label"
                    v-model="this.cliente.telefono2"
                >
                </fg-input>
                
                <!--
                <fg-input
                    type="text"
                    :label="$t('app.profile.fiscal_address.postal_code')"
                    :placeholder="$t('app.profile.fiscal_address.postal_code')"
                    :disabled="true"
                    class="profile-label"
                    v-model="this.cliente.codigoPostal"
                >
                </fg-input>
                -->

            </div>
        </div>
        <div class="row" style="margin-top: 10px" v-if="this.$store.state.user.idCliente > 0">
          <div class="col-12" style="text-align: center">
            <router-link :to="{ name: 'Cambio informacion cliente' }" class="col-2" @click.native="modals.classic = false">
              <n-button type="primary" style="font-size: 1.2rem;">{{ $t("app.modules.customer_information_change.buttons.request") }}</n-button>
            </router-link>
          </div>
        </div>
    </modal>
</template>

<script>
import ConstPerfilesCliente from "@/models/perfil/ConstPerfilesCliente";
export default {
    components:{},
    data(){
        return{
            server: "",
            contactos: [],
            contacto: {},
            clientes: [],
            cliente: {},
            modals: {
                classic: false,
                notice: false,
                mini: false
            },
            imageUrl: '',
            constPerfilesCliente: new ConstPerfilesCliente()
        }
    },
    computed:{
        department(){
            var val = "";
            if(typeof(this.contacto.departamento) !== 'undefined' || this.contacto.departamento !== null){
                console.log(this.contacto.departamento, this.constPerfilesCliente.COMPRAS);
                switch(this.contacto.departamento){
                    case this.constPerfilesCliente.COMPRAS:
                        val = this.$t("app.enums.user_profiles.0002");
                        break;
                    case this.constPerfilesCliente.CREDITO:
                        val = this.$t("app.enums.user_profiles.0005");
                        break;
                    case this.constPerfilesCliente.CALIDAD:
                        val = this.$t("app.enums.user_profiles.0007");
                        break;
                    case this.constPerfilesCliente.ALMACEN:
                        val = this.$t("app.enums.user_profiles.0011");
                        break;
                    default:
                        val = this.contacto.departamento;
                        break;
                }
            }
            return val;
        }
    },
    created(){
        this.server = process.env.VUE_APP_API_ENDPOINT;
    },
    mounted(){
        EventBus.$on("show-profile", async () => {
            this.modals.classic = true;
            this.$swal.fire({
                title: this.$t("app.promps.wait"),
                html:
                '<div class="spinner-border text-primary" style="width: 3rem; height: 3rem;" role="status"><span class="sr-only">Loading...</span></div>',
                showConfirmButton: false
            });

            await this.getProfileData();

            await this.getClientData();

            this.$swal.close();
        });
    },
    methods:{
        async getProfileData(){
            const param = {
                // Poner la referencia al identificador del usuario que inició sesión
                id: this.$store.state.user.idUsuario,
                claveIdioma: "",
                usuario: 0
            }

            await this.$http
            .post(route("Clientes/getContactoClienteIdUsuario"), param)
            .then(
                async response => {
                    if (response.body.code === 200) {
                        this.contactos = response.body.contactos;
                        if(this.contactos.length > 0){
                            this.contacto = this.contactos[0];
                            this.imageUrl = this.server + this.contacto.fotoPerfil;
                        }
                    } else {
                        this.notifyMessage("danger", this.$t("app.promps.error"));
                    }
                },
                error => {
                    console.log(error);
                    this.notifyMessage("danger", this.$t("app.promps.error"));
                }
            ).finally(() => {});
        },
        async getClientData(){
            const param = {
                id: this.$store.state.user.idClienteSAP,
                claveIdioma: this.$store.state.lang,
                usuario: this.$store.state.user.idUsuario
            }

            await this.$http
            .post(route("Clientes/getDetalleClienteSAP"), param)
            .then(
                async response => {
                    if (response.body.code === 200) {
                        this.clientes = response.body.clientes;
                        if(this.clientes.length > 0){
                            this.cliente = this.clientes[0];
                        }
                    } else {
                        this.notifyMessage("danger", this.$t("app.promps.error"));
                    }
                },
                error => {
                    console.log(error);
                    this.notifyMessage("danger", this.$t("app.promps.error"));
                }
            ).finally(() => {});
        },
        closeSesion() {
            this.$router.push({
                name: "Logout"
            });
        },
        handleAvatarSuccess(res, file) {
            // this.imageUrl = URL.createObjectURL(file.raw);
        },
        beforeAvatarUpload(file) {
            const isJPG = file.type === 'image/jpeg';
            const isLt2M = file.size / 1024 / 1024 < 2;

            if (!isJPG) {
            this.$message.error('La imagen debe estar en formato JPG!');
            }

            if (!isLt2M) {
            this.$message.error('La imagen excede los 2MB!');
            }

            return isJPG && isLt2M;
        },
        async handleFile(file){
            let formData = new FormData();
            formData.append("id", this.$store.state.user.idUsuario);
            formData.append("file", file.raw);

            await this.$http.post(route("Clientes/postFotoPerfil"),formData,
                    {
                      headers: {
                        "Content-Type": "multipart/form-data"
                      }
                    }
                  )
                  .then(
                    async response => {
                      if (response.body.code === 200) {
                        this.imageUrl = this.server + response.body.message;
                        this.notifyMessage("success", this.$t("app.promps.save_success"));
                      } else {
                        this.notifyMessage("danger", this.$t("app.promps.error"));
                      }
                    },
                    error => {
                      this.notifyMessage("danger", this.$t("app.promps.error"));
                    }
                  )
                  .finally(() => {});
        }
    }
}
</script>

<style scoped>

.profile-title{
    background-color: #e31d1a;
    color: white;
    text-align: center;
    width: 100%;
}

.profile-img{
  width: 50%;
  height: auto;
}

.profile-label{
    color: black;
}

</style>
